import { FormattedMessage } from "react-intl";

const Templates = () => {
    return (
        <div>
            <p>
                <FormattedMessage
                    id="JiraServiceManagementPricingPageTeam24.features.templates.content.body"
                    defaultMessage="Get templates pre-configured with request types, workflows, and automation to help any team get started with a service experience."
                />
            </p>
        </div>
    );
};

export default Templates;
